import type { LucideIcon } from "lucide-react"
import {
  Salad,
  Soup,
  Fish,
  Beef,
  Drumstick,
  Pizza,
  Croissant,
  Sandwich,
  Cookie,
  CakeSlice,
  IceCream,
  Coffee,
  Wine,
  Beer,
  Martini,
  CupSoda,
  GlassWater,
  Milk,
  Citrus,
  Leaf,
  Flame,
  Wheat,
  UtensilsCrossed,
} from "lucide-react"

type Rule = { test: RegExp; icon: LucideIcon }

const CATEGORY_RULES: Rule[] = [
  { test: /entrada|starter|aperitiv/i, icon: Salad },
  { test: /sopa|caldo|creme/i, icon: Soup },
  { test: /peixe|marisc|bacalh|fish|polvo|lagost/i, icon: Fish },
  { test: /carne|res|vaca|bife|porco|leit[ãa]o|meat/i, icon: Beef },
  { test: /frango|galinha|ave|chicken/i, icon: Drumstick },
  { test: /massa|pizza|italian|espaguet|lasanh/i, icon: Pizza },
  { test: /sobremesa|doce|dessert|pudim|mousse|gelad/i, icon: CakeSlice },
  { test: /bolo|torta|pastr/i, icon: Cookie },
  { test: /caf[eé]|manh[ãa]|pequeno.almo[oç]|breakfast/i, icon: Coffee },
  { test: /sandu[ií]che|hamb[uú]rgue|lanche|snack/i, icon: Sandwich },
  { test: /p[ãa]o|padaria|tosta/i, icon: Croissant },
  { test: /vegetarian|salada|vegano|verdura|salad/i, icon: Salad },
  { test: /guarni[çc]|[ãa]companh|arroz|batata/i, icon: Wheat },
  { test: /grelhad|churrasc|bbq/i, icon: Flame },
]

const DRINK_RULES: Rule[] = [
  { test: /vinh|espumant|champan|wine|prosecc/i, icon: Wine },
  { test: /cervej|beer|luandina|tango|coca.*beer/i, icon: Beer },
  { test: /cocktail|coquetel|gin|vodca|whisk|rum|martini|caipir|mojit/i, icon: Martini },
  { test: /caf[eé]|ch[aá]|capuccino|tea|expresso/i, icon: Coffee },
  { test: /refriger|soda|gasios|t[ôo]nica/i, icon: CupSoda },
  { test: /[áa]gua|water|mineral/i, icon: GlassWater },
  { test: /sumo|suco|nectar|juice|laranj/i, icon: Citrus },
  { test: /leite|milkshake|iogurte|milk/i, icon: Milk },
  { test: /sobremesa.*bebida|licor|digestiv/i, icon: CakeSlice },
]

function matchIcon(nome: string, rules: Rule[], fallback: LucideIcon): LucideIcon {
  for (const rule of rules) {
    if (rule.test.test(nome)) return rule.icon
  }
  return fallback
}

/** Ícone de uma categoria de pratos a partir do nome. */
export function categoryIcon(nome: string): LucideIcon {
  return matchIcon(nome, CATEGORY_RULES, UtensilsCrossed)
}

/** Ícone de uma categoria de bebidas a partir do nome. */
export function drinkCategoryIcon(nome: string): LucideIcon {
  return matchIcon(nome, DRINK_RULES, GlassWater)
}

/** Ícone para um item individual de bebida (usa o próprio nome do item). */
export function drinkItemIcon(nome: string): LucideIcon {
  return matchIcon(nome, DRINK_RULES, GlassWater)
}

/** Ícone do bufete/eventos especiais. */
export const BuffetIcon = Flame
